import { useTranslation } from 'react-i18next'

import { MapPinIcon, XIcon } from '@phosphor-icons/react'
import { useTheme } from 'styled-components'

import { Loading, RadioButtonOptionCard } from '@reveni-io/reveni-ui'

import { getDropOffPointLocationLabel } from '@/DeliveryMethodsPage/helpers'

import { dropOffPointRadioName, searchingDropOffPointsMessages } from './constants'
import * as Styles from './styles'

const DropOffPointList = ({ dropOffPoints, searching, selectedDropOffPoint, onSelect }) => {
  const { t } = useTranslation()
  const theme = useTheme()

  if (searching) {
    return (
      <Styles.StateContainer>
        <Loading show messages={searchingDropOffPointsMessages} />
      </Styles.StateContainer>
    )
  }

  if (!dropOffPoints.length) {
    return (
      <Styles.StateContainer>
        <XIcon size={48} weight="regular" color={theme.colors.red.tone600} />
        <Styles.EmptyMessage type="bodyMRegular" color={theme.colors.red.tone600}>
          {t('No hemos encontrado puntos de recogida cerca de tu dirección. Elige otro método de devolución.')}
        </Styles.EmptyMessage>
      </Styles.StateContainer>
    )
  }

  return (
    <Styles.Container>
      {dropOffPoints.map(dropOffPoint => (
        <RadioButtonOptionCard
          key={dropOffPoint.id}
          name={dropOffPointRadioName}
          value={dropOffPoint.id}
          icon={<MapPinIcon size={24} />}
          title={dropOffPoint.name}
          description={getDropOffPointLocationLabel(dropOffPoint)}
          selected={dropOffPoint.id === selectedDropOffPoint?.id}
          onChange={() => onSelect(dropOffPoint)}
        />
      ))}
    </Styles.Container>
  )
}

export default DropOffPointList
